(function () {
  const EVENT_NAMES = ['variant:change', 'variant:changed', 'product:variant-change'];

  function initAll(root = document) {
    root.querySelectorAll('.inventory-metafield-wrapper:not([data-im-bound="1"])')
      .forEach(initOne);
  }

  function initOne(wrapper) {
    wrapper.setAttribute('data-im-bound', '1');

    const section = wrapper.closest('[id^="shopify-section-"]') || document;
    const container = wrapper.querySelector('.inventory-metafield');
    const tmplNormal = wrapper.querySelector('[data-template="normal"]');
    const tmplZero = wrapper.querySelector('[data-template="zero"]');
    const jsonEl = wrapper.querySelector('.variant-inventory-json');

    let invMap = {};
    try { invMap = JSON.parse(jsonEl?.textContent || '{}'); } catch (e) {}

    function render(qty) {
      if (typeof qty !== 'number' || !container) return;
      container.innerHTML = (qty <= 0 ? (tmplZero?.innerHTML || '') : (tmplNormal?.innerHTML || ''));
    }

    function getForm() {
      return section.querySelector('form[action^="/cart/add"]');
    }

    function getVariantIdFromInput() {
      const idInput = getForm()?.querySelector('input[name="id"]');
      return idInput?.value ? String(idInput.value) : null;
    }

    function getVariantIdFromUrl() {
      try {
        const v = new URL(location.href).searchParams.get('variant');
        return v ? String(v) : null;
      } catch { return null; }
    }

    function getVariantIdBestEffort() {
      return getVariantIdFromInput() || getVariantIdFromUrl();
    }

    function renderForCurrentVariant(sourceNote) {
      const vid = getVariantIdBestEffort();
      if (!vid) return;
      const qty = invMap[vid];
      if (typeof qty === 'number') render(qty);
    }

    renderForCurrentVariant('init');

    const form = getForm();
    if (form) {
      form.addEventListener('change', () => renderForCurrentVariant('form-change'));
      form.addEventListener('input', () => renderForCurrentVariant('form-input'));

      const idInput = form.querySelector('input[name="id"]');
      if (idInput && 'MutationObserver' in window) {
        let prev = idInput.value;
        new MutationObserver(() => {
          if (idInput.value !== prev) {
            prev = idInput.value;
            renderForCurrentVariant('id-mutation');
          }
        }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
      }
    }

    EVENT_NAMES.forEach(name => {
      document.addEventListener(name, (e) => {
        const v = e?.detail?.variant || e?.detail?.variantData || e?.detail;
        const vid = v?.id ? String(v.id) : getVariantIdBestEffort();
        if (vid && typeof invMap[vid] === 'number') render(invMap[vid]);
      }, true);
    });

    hookHistoryOnce();
    window.addEventListener('popstate', () => renderForCurrentVariant('popstate'));
    window.addEventListener('pushstate', () => renderForCurrentVariant('pushstate'));
    window.addEventListener('replacestate', () => renderForCurrentVariant('replacestate'));

    observePrice(section, () => renderForCurrentVariant('price-mutation'));
  }

  function observePrice(sectionRoot, onChange) {
    if (!('MutationObserver' in window)) return;
    const candidates = [
      '[data-product-price]',
      '.price [data-price]',
      '.price__regular',
      '.product__price',
      '.product-price',
      '.price'
    ];
    const priceEl = candidates
      .map(sel => sectionRoot.querySelector(sel))
      .find(Boolean);
    if (!priceEl) return;
    new MutationObserver(() => onChange()).observe(priceEl, {
      childList: true, characterData: true, subtree: true, attributes: true
    });
  }

  let historyPatched = false;
  function hookHistoryOnce() {
    if (historyPatched) return;
    ['pushState', 'replaceState'].forEach(fn => {
      const orig = history[fn];
      if (typeof orig === 'function') {
        history[fn] = function () {
          const ret = orig.apply(this, arguments);
          const evt = new Event(fn === 'pushState' ? 'pushstate' : 'replacestate');
          window.dispatchEvent(evt);
          return ret;
        };
      }
    });
    historyPatched = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target || document));

  if ('MutationObserver' in window) {
    new MutationObserver((muts) => {
      for (const m of muts) {
        m.addedNodes?.forEach((n) => {
          if (!(n instanceof Element)) return;
          if (n.matches?.('.inventory-metafield-wrapper')) initAll(n.parentElement || n);
          const inner = n.querySelector?.('.inventory-metafield-wrapper');
          if (inner) initAll(n);
        });
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
